import { useCallback, useEffect, useState } from "react";
import { Copy, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const agentLink = (ref) => `${window.location.origin}/apply?ref=${ref}`;

export const copy = (text) => navigator.clipboard?.writeText(text).then(() => toast.success("Link copiato"));

export const AgentsPanel = () => {
  const [agents, setAgents] = useState([]);
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const load = useCallback(() => {
    api.get("/admin/agents").then((r) => setAgents(Array.isArray(r.data) ? r.data : [])).catch(() => toast.error("Errore nel caricamento"));
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/agents", f);
      toast.success("Agente creato");
      setF({ name: "", email: "", password: "" });
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };
  const remove = async (a) => {
    if (!window.confirm(`Eliminare l'accesso di ${a.name}? Le sue candidature restano.`)) return;
    await api.delete(`/admin/agents/${a.id}`);
    load();
  };
  const cls = "w-full border-b border-[#1c1418]/30 bg-transparent py-2 outline-none focus:border-[#1c1418]";

  return (
    <div data-testid="agents-panel" className="space-y-10">
      <ul className="divide-y divide-[#1c1418]/15 border-y border-[#1c1418]/15">
        {agents.map((a) => (
          <li key={a.id} data-testid={`agent-row-${a.ref}`} className="flex flex-wrap items-center gap-4 py-5">
            <div className="min-w-[180px]">
              <p className="font-display text-3xl uppercase leading-none">{a.name}</p>
              <p className="mt-1 font-mono text-xs">{a.email}</p>
            </div>
            <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#1c1418]/60">{a.applications} candidature</p>
            <code className="flex-1 truncate bg-[#f4f4f4] px-3 py-2 text-xs">{agentLink(a.ref)}</code>
            <button onClick={() => copy(agentLink(a.ref))} data-testid={`agent-copy-${a.ref}`} className="flex items-center gap-2 border border-[#1c1418] px-4 py-2 font-mono text-xs uppercase tracking-[0.15em]">
              <Copy className="h-4 w-4 text-[#e9458f]" /> Copia link
            </button>
            <button onClick={() => remove(a)} data-testid={`agent-delete-${a.ref}`} aria-label="Elimina agente" className="grid h-9 w-9 place-items-center bg-[#1c1418] text-white"><Trash2 className="h-4 w-4" /></button>
          </li>
        ))}
      </ul>
      <form onSubmit={add} data-testid="agent-create-form" className="grid gap-5 border border-[#1c1418]/20 p-6 md:grid-cols-4 md:items-end">
        <p className="font-display text-2xl uppercase md:col-span-4">Nuovo agente</p>
        <input required placeholder="Nome" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="agent-name-input" className={cls} />
        <input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="agent-email-input" className={cls} />
        <input required minLength={8} placeholder="Password (min 8)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="agent-password-input" className={cls} />
        <button data-testid="agent-create-submit" className="flex items-center justify-center gap-2 bg-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white">
          <Plus className="h-4 w-4 text-[#e9458f]" /> Crea agente
        </button>
      </form>
    </div>
  );
};
